import { __assign, __spreadArray } from "tslib";
import { serverItemsToProGallery, proGalleryItemsToWixCode, } from '@wix/pro-gallery-items-formatter';
import _ from 'lodash';
import imageClientApiService, { getImageMaxDimensions, } from '../services/imageClientService';
import templatesData from '../consts/templatesData';
import { isValidAlbumForEnablingStore, TEMPLATE_MOTHER_SITE_METASITEID, TRANSPARENT_IMAGE_URL, TRANSPARENT_IMAGE_URL_HEIGHT, TRANSPARENT_IMAGE_URL_WIDTH, FULLSCREEN_STYLEPARAMS_KEYS, } from '../consts/uou';
// remove = not needed for version 8
export var getWixCodeAlbumData = function (albumData, sets, _a, location) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, _e = _d.coverMaxSize, coverMaxSize = _e === void 0 ? 0 : _e, _f = _d.isMobile, isMobile = _f === void 0 ? false : _f;
    var template = albumData.template;
    albumData.albumId = albumData.id;
    albumData.ignoreWatermark = !isValidAlbumForEnablingStore(albumData);
    var cover = albumData.cover || templatesData.albumData.cover;
    albumData.coverUrl = imageClientApiService.getCoverUrl(albumData, {
        maxSize: coverMaxSize,
        cover: cover,
    });
    var _g = getImageMaxDimensions(cover, coverMaxSize), targetWidth = _g.targetWidth, targetHeight = _g.targetHeight;
    cover.height = targetHeight;
    cover.width = targetWidth;
    var wixCodeCoverItem = {
        type: 'image',
        src: cover && cover.isSecure
            ? imageClientApiService.getWixCodeImageWithWatermark(cover, !cover.imageToken && !cover.token && albumData.watermark)
            : albumData.coverUrl,
        imageToken: cover && cover.isSecure && (cover.imageToken || cover.token),
    };
    var wixCodeCoverItemDesktop = __assign(__assign({}, wixCodeCoverItem), { width: cover.width, height: cover.height });
    if ((albumData.motherSiteUrl &&
        albumData.motherSiteUrl.indexOf('editor.wix.com') > -1) ||
        albumData.motherSiteMetaSiteId === TEMPLATE_MOTHER_SITE_METASITEID ||
        !albumData.displayBrand) {
        albumData.motherSiteUrl = '';
    }
    albumData.showCart = albumData.isStoreAlbum;
    albumData.freeArtStore = !albumData.isStoreAlbum;
    albumData.transparent =
        (albumData.template &&
            albumData.template.name.indexOf('minimal') === -1 &&
            albumData.template.transparentImageUrl) ||
            imageClientApiService.getImageItemUrl({
                name: TRANSPARENT_IMAGE_URL,
                photoMetadata: {
                    width: TRANSPARENT_IMAGE_URL_WIDTH,
                    height: TRANSPARENT_IMAGE_URL_HEIGHT,
                },
            });
    albumData.coverOptions = {};
    // remove
    albumData.gogOptions = {
        styleParams: {
            watermark: albumData.watermark,
            numbers: {
                itemClick: 2,
            },
        },
        settings: {
            watermark: albumData.watermark,
            freeArtStore: true,
            ignoreFullscreen: true,
            ignoreWatermark: albumData.ignoreWatermark,
        },
    };
    albumData.setPageBackLink = sets.length > 1 ? '/sets' : "/";
    if (sets.length === 0) {
        albumData.listsBackLink = albumData.coverLink = '/set/';
    }
    else {
        albumData.listsBackLink = albumData.coverLink =
            sets.length > 1 ? '/sets' : "/set/".concat(sets[0].id);
    }
    albumData.listBacklink = '/lists';
    albumData.profileBackLink = albumData.listsBackLink;
    if (albumData.displayBrand) {
        if (albumData.brand.type === 'LOGO' && albumData.brand.logo) {
            // editorX using native PG on modern template
            albumData.logoNativePGItem = [
                {
                    type: 'image',
                    src: imageClientApiService.formatImageUrlToCodeFormat(albumData.brand.logo),
                },
            ];
            albumData.logoItems = [
                {
                    type: 'image',
                    src: albumData.brand.logo.mediaUrl,
                },
            ];
            albumData.brand.name = '';
            albumData.logoUrl = albumData.brand.logo.mediaUrl;
        }
    }
    else if (albumData.brand) {
        albumData.brand.name = '';
    }
    // remove
    albumData.gogItems = sets
        .filter(function (x) { return x.items && x.items.length > 0; })
        .map(function (set) {
        var item = set.items[0];
        var src = item.src || item.mediaUrl;
        if (item.type === 'video') {
            try {
                return {
                    type: 'image',
                    title: set.name,
                    src: imageClientApiService.getImageItemUrl({
                        name: item.thumbnail,
                        photoMetadata: { width: 400, height: 600 },
                    }),
                    link: '/set/' + set.id,
                    imageToken: item.imageToken || item.token || '',
                };
            }
            catch (e) {
                console.error('Couldnt get video thumbnail', e);
            }
        }
        else {
            return {
                type: 'image',
                title: set.name,
                src: src,
                link: '/set/' + set.id,
                imageToken: item.imageToken || item.token || '',
            };
        }
    });
    albumData.coverGalleryOption = {
        styleParams: { watermark: albumData.watermark },
        settings: { watermark: albumData.watermark, freeArtStore: true },
    };
    albumData.albumDate = albumData.displayDate ? albumData.albumDate : '';
    albumData.coverItems = [
        {
            type: 'image',
            title: template.reverseCoverTitleAndDescription
                ? albumData.albumDate
                : albumData.albumName,
            description: template.reverseCoverTitleAndDescription
                ? albumData.albumName
                : albumData.albumDate,
            src: albumData.transparent,
        },
    ];
    if (albumData.template.name.indexOf('minimal') === -1 ||
        albumData.template.name.indexOf('classic') === -1) {
        albumData.coverItems[0].width = 104;
        albumData.coverItems[0].height = 48;
    }
    // remove
    albumData.styleParams = _.omit(albumData.styleParams, FULLSCREEN_STYLEPARAMS_KEYS);
    albumData.coverItemMobile = [wixCodeCoverItem];
    if (!albumData.template.coverIsBackground) {
        albumData.coverItems.push(wixCodeCoverItemDesktop);
    }
    if (albumData.template.coverPageName === 'set' ||
        albumData.template.coverPageName === 'sets') {
        if (sets.length === 1) {
            albumData.hideLinkToCover = true;
            albumData.hideLinkToGog = true;
        }
        else if (sets.length > 1) {
            albumData.hideLinkToCover = true;
        }
    }
    albumData.zipUrl = "https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=".concat(albumData.motherSiteMetaSiteId, "&instanceId=").concat(albumData.id, "&state=PUBLISHED");
    // TO REMOVE AFTER PG CUBE RATIO FIX
    // remove
    albumData.styleParams.layoutParams = {
        cropRatio: albumData.styleParams.cubeRatio,
    };
    // remove
    if (isMobile) {
        albumData.styleParams.numberOfImagesPerRow = 1;
    }
    // remove
    if (location &&
        (((_b = location.url) === null || _b === void 0 ? void 0 : _b.includes('/list/')) || ((_c = location.url) === null || _c === void 0 ? void 0 : _c.includes('/lists')))) {
        albumData.allowSelections = true;
    }
    return albumData;
};
export var getWixCodeGalleryItems = function (albumGalleries, albumData) {
    var motherSiteMetaSiteId = albumData.motherSiteMetaSiteId, id = albumData.id;
    albumData.albumId = id;
    var firstGallery = albumGalleries[0];
    albumGalleries.forEach(function (gallery) {
        var serverItems = _.chain(gallery.items)
            .filter(function (x) { return x.mediaUrl; })
            .value();
        serverItems = serverItemsToProGallery(serverItems);
        var thumbnailsItems = _.chain(gallery.items)
            .filter(function (x) { return !x.mediaUrl && x.thumbnail; })
            .value();
        var wixCodeServerItems = proGalleryItemsToWixCode(serverItems).map(function (x) { return (__assign(__assign({}, x), { defaultSetId: firstGallery.id })); });
        var wixCodeThumbnailItems = thumbnailsItems.map(function (x) { return ({
            type: x.mediaType === 'video' ? 'video' : 'image',
            src: x.thumbnail,
            orderIndex: x.orderIndex,
        }); });
        gallery.items = __spreadArray(__spreadArray([], wixCodeServerItems, true), wixCodeThumbnailItems, true);
        gallery.items.forEach(function (item) { var _a; return (item.name = (_a = serverItems.find(function (x) { return x.id === item.id; })) === null || _a === void 0 ? void 0 : _a.mediaUrl); });
    });
    var wixCodeRes = albumGalleries
        .map(function (gallery) { return (__assign(__assign({}, gallery), { zipUrl: "https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=".concat(motherSiteMetaSiteId, "&instanceId=").concat(id, "&state=PUBLISHED&setId=").concat(gallery && gallery.id) })); })
        .filter(function (x) { return x.items && x.items.length > 0; });
    return wixCodeRes;
};
export var getCoverUrl = function (albumData, sets, firstItem) {
    var _a, _b;
    var cover = albumData.cover;
    if (!cover && firstItem) {
        firstItem.name =
            (sets && ((_b = (_a = sets[0]) === null || _a === void 0 ? void 0 : _a.items.find(function (x) { return x.slug === firstItem.id; })) === null || _b === void 0 ? void 0 : _b.name)) || '';
        firstItem.isSecure = true;
        cover = firstItem;
    }
    if (!cover) {
        cover = templatesData.albumData.cover;
    }
    var coverUrl = imageClientApiService.getCoverUrl(albumData, {
        cover: cover,
        maxSize: 500,
    });
    return coverUrl;
};
//# sourceMappingURL=wixCodeDataNormalizer.js.map